import {useNavigate} from 'react-router-dom';
import {useAuth} from '@features/auth';
import {
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import {UserAvatarDoubleBordered} from '@entities/user';
import {useTimezone} from '@shared/hooks';
import {SimplePageLayout} from '@shared/layouts';
import {TIMEZONES} from '@shared/utils';
import {Header} from '@widgets/common';

import {COLOR__GRAY, COLOR__HEADER_BG} from '@/theme/colors';

export const CurrentUserProfilePage = () => {
  const {currentUser, logout} = useAuth();
  const navigate = useNavigate();
  const {name, avatar, username} = currentUser!;
  const {timezone, setTimezone} = useTimezone();

  return (
    <SimplePageLayout
      header={
        <Header title="Profile" minHeight={66} bgcolor={COLOR__HEADER_BG} />
      }
      mainContent={
        <Stack spacing={1} alignItems="center" pt={0.25} mb={4}>
          <UserAvatarDoubleBordered name={name} photoUrl={avatar} size={100} />

          <Typography sx={{fontSize: 20, fontWeight: 800}}>
            {name || username}
          </Typography>

          <Typography variant="b3regular" sx={{color: COLOR__GRAY}}>
            @{username}
          </Typography>

          <Autocomplete
            value={timezone}
            options={TIMEZONES}
            onChange={(_, val) => {
              if (val) setTimezone(val);
            }}
            sx={{width: 320, mt: 2}}
            renderInput={params => (
              <TextField {...params} label="Timezone" size="small" />
            )}
          />

          <Button
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Logout
          </Button>
        </Stack>
      }
    />
  );
};
